import { H1, P1, PrimaryButton } from '@zooplus/ui-components';

import usePageTracking from '@hooks/use-adobe-tracking/use-page-tracking';
import { useTranslation } from '@hooks/use-translations';
import GenericErrorCat from '@public/images/generic-error-cat.svg';
import { reloadPage } from '@utilities/utils';

import styles from './general-error-message.module.scss';

const GeneralErrorMessage = () => {
  const { t } = useTranslation();
  const { trackPageRefreshButtonEvent } = usePageTracking();

  const handleReloadPage = () => {
    trackPageRefreshButtonEvent();
    reloadPage();
  };

  return (
    <div className={styles.errorContainer}>
      <GenericErrorCat
        className={styles.image}
        role="img"
        aria-label={t('cart.error.image.altText')}
      />
      <H1 className={styles.heading}>{t('cart.error.heading')}</H1>
      <P1 className={styles.message}>{t('cart.error.message')}</P1>
      <PrimaryButton onClick={handleReloadPage}>{t('cart.error.reload.button')}</PrimaryButton>
    </div>
  );
};

export default GeneralErrorMessage;
